import React from "react";
import { Grid } from "@material-ui/core";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { DPPageWrapper } from "Components/DP";
import SearchResultsInfo from "./SearchResultsInfo/SearchResultsInfo";
import { UserFilters } from "./UserFilters/UserFilters";
import UserTable from "./UserTable/UserTable";

const UsersPage = () => {
  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.UsersPageViewed,
    });
  };

  return (
    <DPPageWrapper title="Users" onPageLoad={onPageLoad}>
      <Grid container justify="flex-end" alignItems="flex-end">
        <UserFilters />
      </Grid>

      <SearchResultsInfo />

      <UserTable />
    </DPPageWrapper>
  );
};

export default UsersPage;
